import { FC } from 'react';
import styles from './announcement-bar.module.scss';
import { trackLinkClick } from '@/utils/analytics/analytics-utils';

interface IAnnouncementBarProps {
  bodyCopy: string;
  detailsLink?: { name: string; url: string };
}
const AnnouncementBar: FC<IAnnouncementBarProps> = ({ bodyCopy, detailsLink }) => {
  const { url, name } = detailsLink || {};

  const hasDetailsLink = name && url;

  const clickHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
    trackLinkClick({ targetUrl: url });
    e.preventDefault();
    window.open(url);
  };

  return (
    //NB: bodyCopy is required field in Contetnful AnnouncementBar Content Model
    <>
      {hasDetailsLink ? (
        <button className={styles.announcementBar} onClick={clickHandler} tabIndex={0} data-testid="announcement-bar">
          <p className={styles.bodyText}>
            {bodyCopy}
            <span className={styles.link}>{name}</span>
          </p>
        </button>
      ) : (
        <section className={styles.announcementBar}>
          <p className={styles.bodyText}>{bodyCopy}</p>
        </section>
      )}
    </>
  );
};

export default AnnouncementBar;
